import React, { useState } from "react";
import { useTranslation } from "react-i18next"; // Import useTranslation
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [click, setClick] = useState(false);
  const { i18n } = useTranslation();

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);
  const { t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    console.log(lng);
  };

  return (
    <>
      <nav className="navbar">
        <div className="container flex_space">
          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? "fas fa-times" : " fas fa-bars"}></i>
          </div>

          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li>
              <Link to="/" onClick={closeMobileMenu}>
                {t("home")}
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={closeMobileMenu}>
                {t("aboutUs")}
              </Link>
            </li>
            <li>
              <Link to="/gallery" onClick={closeMobileMenu}>
                {t("gallery")}
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={closeMobileMenu}>
                {t("contactUs")}
              </Link>
            </li>
            {/* <li>
              <Link to="/rate" onClick={closeMobileMenu}>
                {t("rate")}
              </Link>
            </li> */}
          </ul>

          <div className="login-area flex">
            <li>
              <Link to="/contact">
                <button className="primary-btn">{t("requestQuote")}</button>
              </Link>
            </li>
          </div>
          <div
            className="language"
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            <img
              src="/images/flag/engll.png"
              alt="English"
              width={"35px"}
              height={"35px"}
              style={{
                borderRadius: "50%",
                cursor: "pointer",
                border: "1px solid black",
                padding: "2px",
              }}
              onClick={() => changeLanguage("en")}
            />
            <img
              src="/images/flag/gei.png"
              alt="German"
              width={"35px"}
              height={"35px"}
              style={{
                borderRadius: "50%",
                cursor: "pointer",
                border: "1px solid black",
                padding: "2px",
              }}
              onClick={() => changeLanguage("ka")}
            />
          </div>
        </div>
      </nav>

      <header>{/* Remaining header elements */}</header>
    </>
  );
};

export default Navbar;
